import "./src/styles/global.css";
import React, { useEffect } from "react";
import { Amplify } from "aws-amplify";
import outputs from "./amplify_outputs.json";
import { GrowthBookProvider } from "@growthbook/growthbook-react";
import growthbook from "./src/utils/growthbook";
import { getCSSVariables, DEFAULT_THEME } from "./src/config/themes";
import { I18nextProvider } from "react-i18next";
import i18n from "./src/i18n";

console.log('🌐 [gatsby-browser] i18next initialized directly');

Amplify.configure(outputs);
console.log('✅ [gatsby-browser] Amplify configured');

// Helper function to get or create user ID cookie
function getClientId() {
  const cookieName = "client_id";
  const match = document.cookie.match(
    new RegExp("(^| )" + cookieName + "=([^;]+)"),
  );

  if (match) {
    return match[2];
  }

  // Generate new user ID
  const newClientId =
    "client_" +
    Math.random().toString(36).substring(2) +
    Date.now().toString(36);

  // Set cookie for 1 year
  const expires = new Date();
  expires.setFullYear(expires.getFullYear() + 1);
  document.cookie = `${cookieName}=${newClientId};expires=${expires.toUTCString()};path=/;SameSite=Lax`;

  return newClientId;
}

const GrowthBookWrapper = ({ children }) => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const clientId = getClientId();

      // Set user attributes for consistent experiment assignment
      growthbook.setAttributes({
        id: clientId,
        url: window.location.href,
        userAgent: navigator.userAgent,
      });

      // Initialize GrowthBook with streaming
      growthbook.init({ streaming: true });

      // Initialize theme on page load
      const savedTheme = localStorage.getItem('site-theme') || DEFAULT_THEME;
      const cssVars = getCSSVariables(savedTheme);
      const root = document.documentElement;

      // Apply theme CSS variables
      Object.entries(cssVars).forEach(([key, value]) => {
        root.style.setProperty(key, value);
      });
    }
  }, []);

  return children;
};

export const wrapRootElement = ({ element }) => {
  return (
    <I18nextProvider i18n={i18n}>
      <GrowthBookProvider growthbook={growthbook}>
        <GrowthBookWrapper>{element}</GrowthBookWrapper>
      </GrowthBookProvider>
    </I18nextProvider>
  );
};

// Protect admin routes - only allow on localhost
export const onRouteUpdate = ({ location }) => {
  if (typeof window !== "undefined" && location.pathname.startsWith("/admin")) {
    const hostname = window.location.hostname;
    const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";

    if (!isLocalhost) {
      window.location.href = "/404";
    }
  }
};
